import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

// **
// Uses SessionStorage for saving data that isn't sensitive/secure in nature
// **
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() {
  }

  // Clear session data when the user logs out
  public clearSessionStorage() {
    // sessionStorage.removeItem(environment.StorageID);
    sessionStorage.removeItem(environment.AccessTokenID);
    sessionStorage.removeItem(environment.TokenIDExpires);
    sessionStorage.removeItem(environment.TokenEmail);
    sessionStorage.removeItem(environment.TokenUserRole);
    sessionStorage.removeItem(environment.UserHospId);
    sessionStorage.removeItem(environment.PendoUserID);
    sessionStorage.removeItem(environment.CommunitiesId);
    sessionStorage.removeItem(environment.TokenSubscriptionsAvailable);
    this.clearHospitalSessionData();
    this.clearUnitSessionData();
  }

  public clearHospitalSessionData() {
    sessionStorage.removeItem(environment.HospitalId);
    sessionStorage.removeItem(environment.HospitalName);
  }

  public clearUnitSessionData() {
    sessionStorage.removeItem(environment.UnitId);
    sessionStorage.removeItem(environment.UnitName);
  }

  public getPendoUserId(): string {
    const id = sessionStorage.getItem(environment.PendoUserID);
    return id;
  }
  public setPendoUserId(pendouser: string) {
    sessionStorage.setItem(environment.PendoUserID, pendouser);
  }

  public getPortalUrl() {
    const link = sessionStorage.getItem(environment.PortalLink);
    return link;
  }
  public setPortalUrl(url: string) {
    sessionStorage.setItem(environment.PortalLink, url);
  }

  public getIndicatorUrl() {
    const link = sessionStorage.getItem(environment.IndicatorLink);
    return link;
  }
  public setIndicatorUrl(url: string) {
    sessionStorage.setItem(environment.IndicatorLink, url);
  }

  public getUserHospitalId(): string {
    const id = sessionStorage.getItem(environment.HospitalId);
    return id;
  }
  public setUserHospitalId(hospid: string) {
    sessionStorage.setItem(environment.HospitalId, hospid);
  }

  public getUserHospitalName(): string {
    const name = sessionStorage.getItem(environment.HospitalName);
    return name;
  }
  public setUserHospitalName(hospName: string) {
    sessionStorage.setItem(environment.HospitalName, hospName);
  }

  public getUnitId(): string {
    const id = sessionStorage.getItem(environment.UnitId);
    return id;
  }
  public setUnitId(unitid: string) {
    sessionStorage.setItem(environment.UnitId, unitid);
  }

  public getUserUnitName(): string {
    const name = sessionStorage.getItem(environment.UnitName);
    return name;
  }
  public setUserUnitName(unitName: string) {
    sessionStorage.setItem(environment.UnitName, unitName);
  }

  public getIndicatorId(): string {
    const id = sessionStorage.getItem(environment.IndicatorId);
    return id;
  }
  public setIndicatorId(indid: string) {
    sessionStorage.setItem(environment.IndicatorId, indid);
  }

  public getUserCommunities(): string {
    let coms = sessionStorage.getItem(environment.CommunitiesId);
    coms = (coms === null) ? "" : coms;
    return coms;
  }
  public setUserCommunities(coms: string) {
    sessionStorage.setItem(environment.CommunitiesId, coms);
  }

  public getSubscription(): string {
    let subid = sessionStorage.getItem(environment.SubscriptionSelected);
    subid = (subid) ? subid : '';
    return subid;
  }
    
  public setSubscription(sub: string) {
    sessionStorage.setItem(environment.SubscriptionSelected, sub.toString());
  }

  public getSubscriptionsAvailable(): string {
    let subs = sessionStorage.getItem(environment.TokenSubscriptionsAvailable);
    subs = (subs === null) ? "" : subs;
    return subs;
  }
  public setSubscriptionsAvailable(s: string) {
    sessionStorage.setItem(environment.TokenSubscriptionsAvailable, s);
  }
}
